import { useState } from 'react';

import { Checkout } from './components/Checkout/Checkout.tsx';
import { CheckoutFetcher } from './components/Checkout/CheckoutFetcher.tsx';
import { PricingTable } from './components/PricingTable.tsx';
import type { Plan, PriceID, SubscriptionModuleMode } from './types.ts';
import { getPlans } from './utils/getPlans.ts';

type Props = {
  plans?: Plan[];
  mode: SubscriptionModuleMode;
  redirectURL: string;
  onPlanSelect?: () => void;
  onFinish: () => void;
};

export const SubscriptionModule = ({
  plans = getPlans(),
  mode,
  redirectURL,
  onPlanSelect,
  onFinish,
}: Props) => {
  const [planInfo, setPlanInfo] = useState<{
    priceID: PriceID;
    interval: 'month' | 'year';
  } | null>(null);

  if (planInfo) {
    const { priceID } = planInfo;

    return (
      <CheckoutFetcher priceID={priceID} isTrial={mode === 'legacy-new-user-trial'}>
        {({ pricingBreakdown }) => (
          <Checkout
            priceID={priceID}
            redirectURL={redirectURL}
            initialPricingBreakdown={pricingBreakdown}
            mode={mode}
            onCheckoutComplete={onFinish}
          />
        )}
      </CheckoutFetcher>
    );
  }

  return (
    <PricingTable
      plans={plans}
      showTrial={mode === 'legacy-new-user-trial'}
      onPlanSelect={({ priceID, interval }) => {
        setPlanInfo({ priceID, interval });
        onPlanSelect?.();
      }}
    />
  );
};
